export interface PatientUpdateErrorResult {
  phoneError: string;
  emailError: string;
  shouldClose: boolean;
  toastMessage: string | undefined;
}

export function parsePatientUpdateError(error: any): PatientUpdateErrorResult {
  if (error.response?.status === 422) {
    const fieldErrors = error.response.data?.errors || {};
    const phoneError = Array.isArray(fieldErrors.phone) ? fieldErrors.phone[0] : '';
    const emailError = Array.isArray(fieldErrors.email) ? fieldErrors.email[0] : '';
    const toastMessage =
      !phoneError && !emailError ? error.response.data?.message : undefined;
    return { phoneError, emailError, shouldClose: false, toastMessage };
  }
  return {
    phoneError: '',
    emailError: '',
    shouldClose: true,
    toastMessage: error.response?.data?.message,
  };
}
